// src/lib/normalize.js
export function normalizeRisk(row) {
  const d = row?.data || {};

  return {
    id: row.id,
    ticker: d.ticker ?? row.instrument ?? row.ticker ?? "",
    balance: d.balance ?? row.account_balance ?? null,
    riskPct: d.riskPct ?? row.risk_per_trade ?? row.risk_percent ?? null,
    entry: d.entry ?? row.entry_price ?? null,
    stop: d.stop ?? row.stop_loss_price ?? row.stop_price ?? null,
    target: d.target ?? row.target_price ?? null,
    riskAmount: d.riskAmount ?? row.risk_amount ?? null,
    positionSize: d.positionSize ?? row.position_size ?? null,
    rrRatio: d.rrRatio ?? row.rr_ratio ?? null,

    // ✅ persisted Risk Engine fields
    riskEngineScore: row.risk_engine_score ?? null,
    riskEngineRiskPercent: row.risk_engine_risk_percent ?? null,
    riskEngineTotalRisk: row.risk_engine_total_risk ?? null,
    riskEngineTotalReward: row.risk_engine_total_reward ?? null,
    riskEngineRR: row.risk_engine_rr ?? null,
    riskEngineStatus: row.risk_engine_status ?? null,
    riskEngineViolations: row.risk_engine_violations ?? [],

    created_at: row.created_at,
  };
}

export function normalizeJournal(row) {
  const d = row?.data || {};

  return {
    id: row.id,
    ticker: d.ticker ?? row.title ?? "",
    notes: row.notes ?? "",
    entry_price: d.entry_price ?? null,
    exit_price: d.exit_price ?? null,
    position_size: d.position_size ?? null,
    created_at: row.created_at,
  };
}